import React from 'react';
import CareersPageComponent from '../components/careers/CareersPage';

const CareersPage: React.FC = () => {
  return <CareersPageComponent />;
};

export default CareersPage;
